import css from './DragAndDrop.module.scss';
import { dragAndDropHandleClass } from './Handle';
import { AutoScroller, DragStartPredicate, GridOptions, ItemDrag } from './muuri';

export const defaultDragPredicate: (itemDrag: typeof ItemDrag) => DragStartPredicate =
  itemDrag => (item, evt) => {
    if (evt.srcEvent.ctrlKey) {
      return false;
    }

    return itemDrag.defaultStartPredicate(item, evt, {
      distance: 2,
      delay: 0,
    });
  };

export const defaultDragHandlePredicate: (itemDrag: typeof ItemDrag) => DragStartPredicate =
  itemDrag => (item, evt) => {
    /**
     * Muuri has support for drag handles out of the box, however the implementation doesn't
     * work properly with react. This is essentially doing the same thing using the drag
     * predicate - check to see if the event came from the drag handle, if so we will
     * drag it.
     */
    if (
      item.getElement()?.attributes.getNamedItem('data-has-drag-handle')?.value === 'true' &&
      evt.target.classList.contains(dragAndDropHandleClass)
    ) {
      return itemDrag.defaultStartPredicate(item, evt);
    } else if (
      item.getElement()?.attributes.getNamedItem('data-has-drag-handle')?.value !== 'true'
    ) {
      return defaultDragPredicate(itemDrag)(item, evt);
    } else {
      // false here essentially forces a noop / do not drag.
      return false;
    }
  };

export const disabledDragPredicate: DragStartPredicate = (item, evt) => false;

export const defaultOptions = (autoscroller: typeof AutoScroller): GridOptions => ({
  dragEnabled: true,
  layoutOnInit: false,
  layoutOnResize: true,
  hiddenStyles: {
    opacity: '0',
  },
  dragPlaceholder: {
    enabled: true,
  },
  itemClass: css['item'],
  itemVisibleClass: css['muuri-item-shown'],
  itemDraggingClass: css['muuri-item-dragging'],
  itemReleasingClass: css['muuri-item-releasing'],
  itemHiddenClass: css['muuri-item-hidden'],
  itemPlaceholderClass: css['muuri-item-placeholder'],
  dragAutoScroll: {
    targets: [window.document.documentElement],
    safeZone: 0.33,
    speed: autoscroller.smoothSpeed(500, 1500, 2000),
  },
});
